import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { defaultTableChange1 } from "../../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleInput from "../../../../../modules/SimpleInput";
import {
  fetchDataAsync,
  FormatCurrencyWithoutSymbol,
} from "../../../../../Services/Utils";
import { ACTIVITY_TYPE, HttpStatus } from "../../../../common/Constants";
import CRMFollowUpH23Filter from "../components/crmFollowUpH23Filter";
import { tabelConfig } from "../config";
import { extractFilter } from "../utils";
import {
  INITIAL_DATE,
  INITIAL_PAGINATION,
  TABS,
  formGroup,
  loyaltyLevelOptions,
  memberLevelOptions,
  prospekCategoryOptions,
  prospekSourceOptions,
  prospekTypeOptions,
  specialCategoryOptions,
} from "../constants";
import CrmFollowUpH23Modifying from "./crmFollowUpH23Modifying";
import Api from "../../../../../Services/Api";
import {
  flattenFormGroupObject,
  mapToObjectDDL,
  removeNullFields,
} from "../../../../common/mapper";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import CrmFollowUpFollowUpH23 from "./crmFollowUpFollowUpH23";
import _ from "lodash";
export default class CrmFollowUpH23Tab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        tanggalAwal: INITIAL_DATE,
        tanggalAkhir: INITIAL_DATE,
      },
      pagination: INITIAL_PAGINATION,
      filterVisible: false,
      submittedFilter: {},
      modifyingVisible: false,
      selectedData: null,
      activityType: null,
      alertInfo: {
        title: null,
        content: null,
        type: null,
        additionalData: null,
      },
      followupVisibility: {
        visible: false,
        id: null,
      },
      skipNextPaginationFetch: false,
      followUpWAData: [],
    };
  }

  componentDidMount() {
    if (this.props.selectedCabang) {
      this.fetchData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const currCabang = this.props.selectedCabang?.value;
    const prevCabang = prevProps?.selectedCabang?.value;

    const currPagination = this.state?.pagination;
    const prevPagination = prevState?.pagination;

    if (currCabang !== prevCabang) {
      this.setState(
        {
          pagination: INITIAL_PAGINATION,
          submittedFilter: {},
          search: {
            tanggalAwal: INITIAL_DATE,
            tanggalAkhir: INITIAL_DATE,
          },
          skipNextPaginationFetch: true
        },
        () => {
          this.fetchData();
        },
      );
    }

    if (
      (prevPagination.page !== currPagination.page ||
        prevPagination.limit !== currPagination.limit) &&
      !this.state.skipNextPaginationFetch
    ) {
      this.fetchData(
        this.state.submittedFilter,
        currPagination.page,
        currPagination.limit
      );
    }

    if (this.state.skipNextPaginationFetch) {
      this.setState({
        skipNextPaginationFetch: false,
      });
    }
  }

  fetchData = async (filter) => {
    const { submittedFilter, search, pagination } = this.state;
    const { selectedCabang, tab, setError, auth, user, onTriggerLoading } =
      this.props;
    let request = filter
      ? {
          ...filter,
          tanggalProspek: removeNullFields(filter?.tanggalProspek || {}),
          fuDate: removeNullFields(filter?.fuDate || {}),
          appointmentDate: removeNullFields(filter?.appointmentDate || {}),
          kodeCabang: selectedCabang?.value,
          idProvince: filter?.province?.value,
          idKabkot: filter?.kabkot?.value,
          kecamatan: filter?.kecamatan?.value,
          kelurahan: filter?.kelurahan?.value,
          kodePos: filter?.kodePos?.value,
          status: _.snakeCase(tab)?.toUpperCase(),
        }
      : !_.isEmpty(submittedFilter)
      ? {
          ...submittedFilter,
          tanggalProspek: removeNullFields(
            submittedFilter?.tanggalProspek || {}
          ),
          fuDate: removeNullFields(submittedFilter?.fuDate || {}),
          appointmentDate: removeNullFields(
            submittedFilter?.appointmentDate || {}
          ),
          kodeCabang: selectedCabang?.value,
          idProvince: submittedFilter?.idProvince?.value,
          idKabkot: submittedFilter?.idKabkot?.value,
          kecamatan: submittedFilter?.kecamatan?.value,
          kelurahan: submittedFilter?.kelurahan?.value,
          kodePos: submittedFilter?.kodePos?.value,
          status: _.snakeCase(tab)?.toUpperCase(),
        }
        : {
          status: _.snakeCase(tab)?.toUpperCase(),
          startDate: search.tanggalAwal || null,
          endDate: search.tanggalAkhir || null,
          kodeCabang: selectedCabang?.value,
        };

    this.setState((prevValue) => ({
      ...prevValue,
      submittedFilter: filter !== undefined ? filter : submittedFilter,
    }));
    request = extractFilter(request);

    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").findAllDataFU,
      setError: setError,
      menuName: "CRM H23 - Follow Up Prospect",
      args: {
        ...removeNullFields(request),
        limit: pagination.limit,
        page: pagination.page,
        userLogin: auth?.user?.idUser,
        adminLine: user?.user.administrationLine,
        prospectCategory: "H23",
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data,
        pagination: {
          ...prevValue.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
  };

  handlePeriodeChange = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      search: {
        ...prev.search,
        [name]: moment(value).format("DD-MM-YYYY"),
      },
    }));
  };

  handleFilterVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      filterVisible: !prev.filterVisible,
    }));
  };

  getTableConfig = () => {
    const { tab } = this.props;
    return tabelConfig({
      status: _.snakeCase(tab)?.toUpperCase(),
      handleDetailVisibility: this.handleModifyingVisibility,
      handleFollowUpVisible: this.handleFollowUpVisibility,
    });
  };

  handleModifyingVisibility = async (value, activityType) => {
    if (value) {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailFU,
        setError: this.props.setError,
        menuName: "CRM - Follow Up Prospect",
        args: value,
      });
      if (res.ok) {
        let body = res.data.data;
        const data = {
          ...body,
          name: body.prospect.name,
          nik: body.prospect.nik,
          address: body.prospect.address,
          provinceId: mapToObjectDDL(
            body.prospect.province.provinceName,
            body.prospect.province.id
          ),
          kabkotId: mapToObjectDDL(
            body.prospect.kabKot.kabKotName,
            body.prospect.kabKot.kabKotId
          ),
          kecamatanId: mapToObjectDDL(
            body.prospect.kecamatan.kecamatanName,
            body.prospect.kecamatan.id
          ),
          kelurahanId: mapToObjectDDL(
            body.prospect.kelurahan.kelurahanname,
            body.prospect.kelurahan.id
          ),
          zipcode: mapToObjectDDL(body.prospect.kodePos, body.prospect.kodePos),
          gender: mapToObjectDDL(
            body.prospect.gender?.value,
            body.prospect.gender?.key
          ),
          job1: mapToObjectDDL(
            body.prospect.job1.value,
            body.prospect.job1.key
          ),
          job2: mapToObjectDDL(
            body.prospect.job2?.value,
            body.prospect.job2?.key
          ),
          religion: mapToObjectDDL(
            body.prospect.religion.value,
            body.prospect.religion.key
          ),
          hpNumber1: body.prospect.hpNumber1,
          hpNumber2: body.prospect.hpNumber2,
          email: body.prospect.email,
          facebook: body.prospect.facebook,
          instagram: body.prospect.instagram,
          linkedin: body.prospect.linkedin,
          twitter: body.prospect.x,
          tiktok: body.prospect.tiktok,
          discCategory: mapToObjectDDL(
            body.prospect.discountCategory,
            body.prospect.discountCategory
          ),
          hobby: body.prospect.hobby?.map((h) =>
            mapToObjectDDL(h.value, h.key)
          ),
          interest: body.prospect.interest?.map((h) =>
            mapToObjectDDL(h.value, h.key)
          ),
          customerId: body.prospect.member.customerId,
          memberLevel: memberLevelOptions.find(
            (item) => item.value === body.prospect.member.memberLevel
          ),
          loyaltyLevel: loyaltyLevelOptions.find(
            (item) => item.value === body.prospect.member.loyaltyMember
          ),
          specialCategory: specialCategoryOptions.find(
            (item) => item.value === body.prospect.member.specialCategory
          ),
          specialNotes: body.prospect.member.specialNotes,
          photoCustomerUrl: body.prospect.member.photoCustomerUrl,
          prospectId: body.prospectId,
          kodeCabang: body.kodeCabang.kodeCabang,
          prospectDate: body.prospectDate,
          category: prospekCategoryOptions.find(
            (item) => item.value === body.prospect.prospectCategory
          ),
          source: prospekSourceOptions.find(
            (item) => item.value === body.prospect.prospectSource
          ),
          sourceCabang: body.prospect.sourceCabang?.namaDealer,
          lastFollowUpBy: body.prospect.lastUpdateByUser?.name,
          type: prospekTypeOptions.find(
            (item) => item.value === body.prospect.type
          ),
          prospectOwnership: body.prospect.userProspectOwner.name,
          lastSeller: body.prospect.userLastSeller?.name,
        };
        this.setState((prevValue) => ({
          ...prevValue,
          selectedData: data,
          activityType: activityType,
          modifyingVisible: true,
        }));
      }
      return;
    } else {
      this.setState((prev) => ({
        ...prev,
        activityType: activityType,
        selectedData: null,
        modifyingVisible: !prev.modifyingVisible,
      }));
    }
  };

  submitProspect = async (payload) => {
    const { onTriggerLoading, setError } = this.props;
    onTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").saveFUProspect,
      menuName: "CRM - Follow Up Prospek",
      setError: setError,
      args: payload,
    });
    await this.setState((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        totalData: 0,
      },
      skipNextPaginationFetch: true,
    }));
    this.fetchData();
    this.handleModifyingVisibility();
    onTriggerLoading();
  };

  checkFUProspect = async (controls, payload) => {
    const { setError, onTriggerLoading } = this.props;
    onTriggerLoading();
    const request = {
      nik: controls.nik,
      category: controls.category?.value,
    };
    if (controls.prospectId) {
      request.prospectId = controls.prospectId;
    }
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkFUProspect,
      menuName: "CRM H23 - Follow Up Prospek",
      setError: setError,
      args: request,
    });
    if (res.ok) {
      if (res.data.data.status) {
        this.handleAlertInfoVisibility(
          "Informasi",
          <div>
            <p>Data Customer sudah memiliki prospek dengan</p>
            <p>{`nomor Prospek : ${res.data.data.prospectId}`}</p>
            <p>Penambahan prospek diabaikan</p>
          </div>
        );
      } else {
        this.submitProspect(payload);
      }
    }
    onTriggerLoading();
  };

  handleAlertInfoVisibility = (title, content, type, additionalData) => {
    this.setState((prev) => ({
      ...prev,
      alertInfo: {
        ...prev.alertInfo,
        visible: !prev.alertInfo.visible,
        title: title,
        content: content,
        type: type || "info",
        additionalData: additionalData,
      },
    }));
  };

  handleDeleteProspect = (value) => {
    console.log(value)
    this.handleAlertInfoVisibility(
      "Peringatan",
      <div>
        <p>Prospek akan dihapus. Apakah</p>
        <p>anda yakin?</p>
      </div>,
      "delete",
      value
    );
  };

  handleProcessDeleteProspect = async () => {
    const { onTriggerLoading, setError } = this.props;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").deleteFollowUpProspect,
      menuName: "CRM - Follow Up Prospek",
      setError: setError,
      args: this.state.alertInfo.additionalData,
    });
    this.handleAlertInfoVisibility();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleModifyingVisibility();
      this.setState((prevValue) => ({
        ...prevValue,
        pagination: {
          ...prevValue.pagination,
          totalData: 0,
        }
      }));
      this.fetchData()
      this.handleAlertInfoVisibility("Informasi", res.data.data);
    }
    onTriggerLoading();
  };

  handleAcceptAlert = () => {
    const { alertInfo } = this.state;
    if (alertInfo.type === "delete") {
      this.handleProcessDeleteProspect();
      return;
    }
    if (alertInfo.type === "confirmation_followup") {
      this.handleProcessFollowUpProspect();
      return;
    }
    if (alertInfo.type === "followup_wa") {
      this.handleProcessFollowUpWA();
      return;
    }
  };

  handleFollowUpVisibility = (value) => {
    this.setState((prev) => ({
      ...prev,
      followupVisibility: {
        visible: !prev.followupVisibility.visible,
        id: value,
      },
    }));
  };

  handleProcessFollowUpProspect = async () => {
    const { onTriggerLoading, setError, selectedCabang } = this.props;
    const { alertInfo, followupVisibility } = this.state;

    let dataProspect = {};
    let dataCustomer = {};
    onTriggerLoading();
    let resDetail = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailFU,
      setError: this.props.setError,
      menuName: "CRM - Follow Up Prospect",
      args: followupVisibility.id,
    });
    if (resDetail.ok) {
      let data = resDetail.data.data;
      dataCustomer = {
        nik: data.prospect.nik,
        name: data.prospect.name,
      };
      const userId = localStorage.getItem("userId");
      dataProspect = {
        idUserLastSeller: data.prospect.userLastSeller?.id ? userId : null,
        idLastUpdateByUser: userId,
      };
    }

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").saveFUProspect,
      setError: setError,
      menuName: "CRM - Follow Up Prospek",
      args: {
        prospectId: followupVisibility.id,
        kodeCabang: selectedCabang.value,
        dataFollowUpProspect: { ...alertInfo.additionalData },
        dataProspectCustomer: { dataProspect, dataCustomer },
      },
    });
    onTriggerLoading();
    this.handleAlertInfoVisibility();
    if (res?.ok && res?.data?.status === HttpStatus.SUCCESS) {
      this.handleFollowUpVisibility();
      this.setState((prevValue) => ({
        ...prevValue,
        pagination: {
          ...prevValue.pagination,
          totalData: 0,
        },
        skipNextPaginationFetch: true
      }));
      this.fetchData()
    }

    const message = res?.data?.message || "";
    if (message?.startsWith("Pengajuan tidak dapat dilakukan ")) {
      this.handleAlertInfoVisibility(
        "Informasi",
        res?.data?.message || "Terjadi Kesalahan pada server"
      );
    }
  };

  handleProcessFollowUpWA = async () => {
    const { onTriggerLoading, setError } = this.props;
    const { followUpWAData } = this.state;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").followUpWa,
      menuName: "CRM H23 - Follow Up Prospek",
      setError: setError,
      args: followUpWAData,
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleAlertInfoVisibility();
      this.setState((prevValue) => ({
        ...prevValue,
        pagination: {
          ...prevValue.pagination,
          totalData: 0,
        },
        search: {
          ...prevValue.search,
          tanggalProspek: {
            tanggalAwal: moment(Date.now()).format("DD-MM-YYYY"),
            tanggalAkhir: moment(Date.now()).format("DD-MM-YYYY"),
          },
        },
        skipNextPaginationFetch: true
      }));
      this.fetchData()
    }
  };

  handleSubmitFollowUp = (data) => {
    const { followupVisibility } = this.state;
    const content =
      data?.status?.toLowerCase() === "drop" ||
      data?.status?.toLowerCase() === "death" ? (
        <div>
          <p>
            Follow Up dengan No prospek <b>{followupVisibility.id}</b> akan
            ditambahkan dan membutuhkan <b>approval.</b>
          </p>
          <p>Apakah anda yakin?</p>
        </div>
      ) : (
        <div>
          <p>Follow Up akan ditambahkan</p>
          <p>Apakah anda yakin?</p>
        </div>
      );

    this.handleAlertInfoVisibility(
      "Informasi",
      content,
      "confirmation_followup",
      data
    );
  };

  handleFollowUpWA = () => {
    const { followUpWAData } = this.state;
    this.handleAlertInfoVisibility(
      "Pertanyaan",
      `Follow Up Pelanggan sebanyak ${followUpWAData.length} di buat. Apakah anda yakin?`,
      "followup_wa"
    );
  };

  handleSelectRow = (listIndex) => {
    const selectedData = listIndex.map(
      (index) => this.state.dataTable[index]?.noProspek
    );

    this.setState({
      followUpWAData: selectedData,
    });
  };

  handleSubmitFilter = (filter, resetFilter) => {
    this.handleFilterVisibility();
    this.setState(
      (prevState) => ({
        submittedFilter: filter,
        search: {
          ...prevState.search,
          tanggalProspek: {
            tanggalAwal: resetFilter
              ? moment(Date.now()).format("DD-MM-YYYY")
              : null,
            tanggalAkhir: resetFilter
              ? moment(Date.now()).format("DD-MM-YYYY")
              : null,
          },
        },
        pagination: {
          ...prevState.pagination,
          page: 1,
          totalData: 0
        },
        skipNextPaginationFetch: true,
      }),
      async () => {
        this.fetchData(resetFilter ? null : filter);
      }
    );
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleSearch = () => {
    this.setState(
      (prevState) => ({
        pagination: {
          ...prevState.pagination,
          page: 1,
          totalData: 0
        },
        skipNextPaginationFetch: true,
      }),
      async () => {
        this.fetchData();
      }
    );
  };

  render() {
    const {
      search,
      dataTable,
      pagination,
      filterVisible,
      submittedFilter,
      modifyingVisible,
      selectedData,
      activityType,
      alertInfo,
      followupVisibility,
    } = this.state;
    const { tab } = this.props;
    const isShowFUWA = [TABS.NON_FOLLOW_UP, TABS.ONGOING].includes(tab);
    console.log(this.state.pagination)
    return (
      <React.Fragment>
        <FlexView style={{ justifyContent: "space-between" }}>
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <p className="margin-bottom-20px">Periode: </p>
            <SimpleDate
              id="select_prospek_date_period_from"
              name="tanggalAwal"
              nextdate
              date={search.tanggalAwal}
              maxDate={search.tanggalAkhir}
              onChange={(value) =>
                this.handlePeriodeChange("tanggalAwal", value)
              }
            />
            <span className="margin-bottom-20px">s/d</span>
            <SimpleDate
              id="select_prospek_date_period_to"
              name="tanggalAkhir"
              backdate
              date={search.tanggalAkhir}
              minDate={search.tanggalAwal}
              onChange={(value) =>
                this.handlePeriodeChange("tanggalAkhir", value)
              }
            />
            <SimpleButton
              className="margin-bottom-20px"
              onClick={this.handleSearch}
            >
              Cari
            </SimpleButton>
          </FlexView>
          <SimpleButton
            className={"btn background-red margin-bottom-20px"}
            styles={{ width: "unset" }}
            onClick={this.handleFilterVisibility}
            icon={<i className="fa fa-qrcode"></i>}
          />
        </FlexView>
        <SimpleDataTable
          data={dataTable}
          columns={this.getTableConfig()}
          toCount={pagination.totalData}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          options={{
            ...defaultTableChange1(
              this.handleChangePage,
              this.handleRowsPerPage,
              this.handleSelectRow
            ),
            selectableRows: isShowFUWA,
          }}
          footerAdditionalButtons={
            <FlexView>
              {isShowFUWA && (
                <SimpleButton
                  text="FOLLOW UP WA"
                  onClick={this.handleFollowUpWA}
                />
              )}
              <SimpleButton
                icon={<i className="fa fa-plus margin-right-10px"></i>}
                text="Tambah"
                onClick={() =>
                  this.handleModifyingVisibility(null, ACTIVITY_TYPE.CREATE)
                }
              />
            </FlexView>
          }
        />
        <FlexView style={{ justifyContent: "end", marginTop: "10px" }}>
          <SimpleInput
            box="number"
            name="totalData"
            displayType="text"
            containerclassname="display-flex gap-20px"
            label={`Total Data ${tab}`}
            value={FormatCurrencyWithoutSymbol({
              number: pagination.totalData || 0,
            })}
          />
        </FlexView>
        {filterVisible && (
          <CRMFollowUpH23Filter
            search={submittedFilter}
            visible={filterVisible}
            onClickClose={this.handleFilterVisibility}
            onSubmit={this.handleSubmitFilter}
          />
        )}
        {modifyingVisible && (
          <CrmFollowUpH23Modifying
            {...this.props}
            formGroup={formGroup}
            initialValues={selectedData}
            visible={modifyingVisible}
            onClickClose={this.handleModifyingVisibility}
            onRefresh={() => this.handleRefresh()}
            onDeleteProspect={this.handleDeleteProspect}
            onAlertInfoChange={this.handleAlertInfoVisibility}
            onSubmit={this.checkFUProspect}
            activityType={activityType}
            title={
              activityType === ACTIVITY_TYPE.VIEW
                ? "History Follow Up"
                : activityType === ACTIVITY_TYPE.CREATE
                ? "Create Prospek"
                : ""
            }
          />
        )}
        {alertInfo?.visible && (
          <SimpleAlert
            title={alertInfo?.title}
            content={<p>{alertInfo?.content}</p>}
            visible={alertInfo?.visible}
            onClickClose={() => this.handleAlertInfoVisibility()}
            additionalButtons={
              alertInfo.type === "info" ? (
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={() => this.handleAlertInfoVisibility()}
                />
              ) : (
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                  <SimpleButton
                    onClick={() => this.handleAlertInfoVisibility()}
                  >
                    Batal
                  </SimpleButton>
                  <SimpleButton onClick={() => this.handleAcceptAlert()}>
                    Iya
                  </SimpleButton>
                </FlexView>
              )
            }
          />
        )}
        {followupVisibility && (
          <CrmFollowUpFollowUpH23
            {...this.props}
            visible={followupVisibility.visible}
            onClickClose={this.handleFollowUpVisibility}
            onSubmit={this.handleSubmitFollowUp}
          />
        )}
      </React.Fragment>
    );
  }
}
